import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_COMPLAINTS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_COMPLAINT:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_COMPLAINT:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_COMPLAINT:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_COMPLAINT:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
